module.exports = __webpack_public_path__ + "img/pie.3e63290c.png";